/* istanbul ignore file */
import axios, { AxiosError, AxiosResponse } from 'axios';
import { ActivityLogsModel } from '../../types/generated/activityLogsModel';
import { ActivityLogsSearchModel } from '../../types/generated/activityLogsSearchModel';

export const searchActivityLogs = (payload: ActivityLogsSearchModel) =>
    axios
        .post(`testapp/activities`, { ...payload })
        .then((res: AxiosResponse<ActivityLogsModel[]>): ActivityLogsModel[] => {
            const { data } = res;
            return data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });

export const getActivityLogById = (id: string) =>
    axios
        .get(`testapp/activities/${id}`)
        .then((res: AxiosResponse<ActivityLogsModel>): ActivityLogsModel => {
            const { data } = res;
            return data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
